import React from 'react'
import { browserHistory } from 'react-router'
import { user } from '../../../core/controllers/user';
import TenantTable from '../../../components/Admin/Tenants/TenantTable';
import NavLink from '../../../components/Routes/NavLink';

import NewTenantsCard from '../../../components/Admin/Tenants/NewTenantsCard'
import ExpiringLeasesCard from '../../../components/Admin/Tenants/ExpiringLeasesCard'
import LateOnRentCard from '../../../components/Admin/Tenants/LateOnRentCard'
import TotalTenantsCard from '../../../components/Admin/Tenants/TotalTenantsCard'

export default class AdminSensors extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            buildingData: null
        }
    }

    componentDidMount() {
        //TODO: API to retrieve buildingData
    }

    componentDidUpdate() {
        if (user.userInfo.user_type_alias != 'super-admin') {
            browserHistory.replace('/');
        }
    }

    render(){
        return (
            <div>
                {(this.state.buildingData != null && this.state.buildingData.length > 0) ? (
                <div class="row">
                    <div class="main-page-header-row col-md-12">
                        <div class="col-md-3">
                            <span class="main-page-header-title">Sensors</span>
                        </div>
                        <div class="col-md-2 col-md-offset-7">
                            <NavLink to={"/admin/sensors"}> {/* TODO: change NavLink to the correct path */}
                                <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                    Add Building
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
                ) : (
                    <div>
                        <div style={{textAlign: "center"}}>
                            <div class="row">
                                <div class="main-page-header-row col-md-12">
                                    <div class="row">
                                        <span class="main-page-header-title">No Buildings Yet</span>
                                    </div>
                                    <div class="row" style={{marginTop: "10px"}}>
                                        <NavLink to={"/admin/sensors"}> {/* TODO: change NavLink to the correct path */}
                                            <button type="button" id="add-building" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                                Add Building
                                            </button>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style={{backgroundImage: "url('/assets/img/connected.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '565px'}}></div>
                    </div>
                )}
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Admin/Sensors/AdminSensors.jsx